const fieldsService = {
  USER_SERVICES: [
     'NAME', 'URL', 'STATUS', 'ACTIONS'
  ],
  USER_ACCOUNTS: [
     'USER_NAME', 'STATUS', 'SERVICE', 'MODULE-ROLE', 'ACTIONS'
  ],
  USER_ACCOUNTS_PARTNER: [
    'USER_NAME', 'ROLE', 'STATUS', 'ACTIONS'
  ],
  USER_PROFILES: [
     'FIRST_NAME', 'LAST_NAME', 'CONTACT_PHONE', 'CONTACT_FAX', 'STATUS', 'ACTIONS'
  ],
  USER_ROLES: [
     'NAME', 'STATUS', 'ACTIONS'
  ],
  USER_STATES: [
     'CHALLENGE_TOKEN', 'COUNTER', 'SOURCE_CITY', 'SOURCE_COUNTRY_CODE', 'SOURCE_IP'
  ],
  USER_EVENTS: [
    'userName', 'page', 'eventName', 'createdAt'
  ]
}
export default fieldsService
